import React from 'react';
import config from '@config';
import { markOnboardingPendingIfNeeded } from './onboarding';

/**
 * Registro de onboardings. Cada uno se muestra UNA sola vez por usuario
 * (estado en localStorage namespaceado por `id`).
 *
 * Modo de disparo:
 *  - immediate: false  -> se muestra después de un login/signup (se setea "pending"
 *                         en esos eventos). Es el comportamiento original.
 *  - immediate: true   -> se muestra ya, sin necesidad de re-loguearse, a cualquier
 *                         usuario logueado que no lo haya visto.
 *
 * Para agregar uno nuevo: sumá un objeto a este array con un `id` único y estable.
 * Mientras `slides` esté vacío, el onboarding no se muestra.
 */
export const ONBOARDINGS = [
  {
    id: null, // bienvenida (legacy: mantiene las claves de localStorage actuales)
    variant: 'welcome',
    immediate: false,
    slides: [
      {
        id: 'step-1',
        title: 'Mi Prode',
        paragraphs: [
          <>
            Es tu pronóstico de todos los partidos para el Mundial de Fútbol 2026.
          </>,
        ],
        imageSrc: `${config.basePath}/img/mi-prode-tutorial.png`,
        imageAlt: 'Imagen onboarding paso 1',
      },
      {
        id: 'step-2',
        title: '¡Jugá por premios increíbles!',
        paragraphs: [
          <>No sólo buscamos al que más sabe, también premiamos tu pasión.</>,
          <>
            <strong>
              Los mejores del ranking se llevarán grandes sorpresas y beneficios exclusivos.
            </strong>{' '}
            ¡Cuanto más arriba estés, mejores serán tus chances de ganar!
          </>,
        ],
        imageSrc: `${config.basePath}/img/premios-tutorial.png`,
        imageAlt: 'Imagen onboarding paso 2',
      },
      {
        id: 'step-3',
        title: '¿Cómo sumar puntos?',
        paragraphs: [
          <>
            <strong>Revisá las reglas del juego</strong> para entender cómo calculamos tus
            aciertos y cuáles son los plazos de carga para cada fase del mundial.
          </>,
        ],
        imageSrc: `${config.basePath}/img/reglas-tutorial.png`,
        imageAlt: 'Imagen onboarding paso 3',
      },
    ],
  },
  {
    id: 'comodines-2026', // NUEVO: aparece sin re-login, una sola vez
    variant: 'comodines',
    immediate: true,
    slides: [
      {
        id: 'step-1',
        title: '¿Te equivocaste en el pronóstico?',
        paragraphs: [
          <>
            <strong className='red'>Si sos SOCI@ de Página|12</strong> contás con un superpoder: <strong>podés hacer hasta 3 cambios en tu Prode y seguír jugando.</strong>
          </>,
        ],
        imageSrc: `${config.basePath}/img/comodines_onboarding_1.png`,
        imageAlt: 'Pronóstico de un grupo y tres monedas con los cambios disponibles',
      },
      {
        id: 'step-2',
        title: '¿Cómo activar los cambios?',
        paragraphs: [
          <><strong className='red'>¡Suscribite al Plan Anual</strong> y obtené 3 posibilidades para seguir sumando puntos y ganarte los premios del Prode de <strong>Página|12!</strong></>,
        ],
        imageSrc: `${config.basePath}/img/comodines_onboarding_2.png`,
        imageAlt: 'Tres monedas numeradas del 1 al 3 que representan los cambios',
      },
    ],
  },
];

const hasSlides = (o) => Array.isArray(o.slides) && o.slides.length > 0;

/** Marca "pending" (en login/signup) los onboardings que dependen de auth. */
export const markPendingOnboardings = (userId, storage) => {
  if (!userId) return;
  ONBOARDINGS
    .filter((o) => !o.immediate && hasSlides(o))
    .forEach((o) => markOnboardingPendingIfNeeded(userId, o.id, storage));
};
